import { Chart, ChartArea, ChartCategoryAxis, ChartCategoryAxisItem, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle, ChartTooltip } from "@progress/kendo-react-charts";
import { Switch } from "@progress/kendo-react-inputs";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import "hammerjs";
import { Fragment, useCallback, useEffect, useState } from "react";
import SweetAlertService from "../../../services/SweetAlertService";
import ReportService from "../Services/ReportService";
import moment from "moment";

export const WeeklyBreakDown = (props: any) => {
    //to expand the accordion
    const [expanded, setExpanded] = useState<any>();
    const [clickedSegment, setClickedSegment] = useState<any>({ name: "", totalHours: 0, totalMinutes: 0, id: 0 });

    //for donut chart 
    const [totalHours, setTotalHours] = useState<any>();
    const [totalMinutes, setTotalMinutes] = useState<any>();
    const [totalNumberOfWeeks, setTotalNumberOfWeeks] = useState<any>();
    const [notes, setNotes] = useState<any>([]);
    const [isDccExceededContract, setIsDccExceededContract] = useState<any>();
    const [isIccExceededContract, setIsIccExceededContract] = useState<any>();
    const [totalSessions, setTotalSessions] = useState<any>();
    const [weekCommencing, setWeekCommencing] = useState<any>();
    const [contractedSessions, setContractedSessions] = useState<any>();
    const [iccPercentage, setIccPercentage] = useState<any>();
    const [contractPercentage, setContractPercentage] = useState<any>();

    //for leave and pubic holiday toggle
    const [isPublicHolidayExistInPeriod, setIsPublicHolidayExistInPeriod] = useState<any>(false);
    const [isPublicHolidayExistsInAllWeeks, setIsPublicHolidayExistsInAllWeeks] = useState<any>(false);
    const [isLeaveExistInPeriod, setIsLeaveExistInPeriod] = useState<any>(false);
    const [isLeaveExistsInAllWeeks, setIsLeaveExistsInAllWeeks] = useState<any>(false);
    const [isExcludeLeaveToggelChecked, setIsExcludeLeaveToggelChecked] = useState<any>(false);
    const [isExcludePublicHolidayToggelChecked, setIsExcludePublicHolidayToggelChecked] = useState<any>(false);
    const [showErrorMessageForLeaveToggle, setShowErrorMessageForLeaveToggle] = useState<any>(false);
    const [showErrorMessageForPublicHolidayToggle, setShowErrorMessageForPublicHolidayToggle] = useState<any>(false);

    //for categories 
    const [categories, setCategories] = useState<any>([]);
    const [categoriesCopy, setCategoriesCopy] = useState<any>([]);

    //for sub categories
    const [subCategories, setSubCategories] = useState<any>([]);
    const [subCategoriesCopy, setSubCategoriesCopy] = useState<any>([]);

    const [weeklyBreakdownData, setWeeklyBreakdownData] = useState<any>([]);

    //line chart
    const [lineChartCategories, setLineChartCategories] = useState<any>([]);

    //for weeklyBreakDownResponse
    const [weeklyBreakDownResponse, setWeeklyBreakDownResponse] = useState<any>();

    //To get color for line chart
    const getColorForLineChart = (item: any) => {
        let map = new Map<number, string>();
        map.set(1, '#0967B1');
        map.set(2, '#DA1F6C');
        map.set(3, '#008E82');
        map.set(4, '#6F4F9B');
        map.set(5, '#EA580D');
        map.set(-888, 'grey');
        map.set(-999, '#FFDF00');

        if (item.isUserDefined) {
            return '#76A227'
        } else {
            return map.get(item.categoryId);
        }
    }

    //To map the catgories for line chart
    const mapSeries = (item: any, index : any) => {
        return (
            <ChartSeriesItem key={index} data={item.totalWorkHours} type="line"
                color={getColorForLineChart(item)}
                width={(item.categoryId === -999) || (item.categoryId === -888) ? 2 : 1}
                dashType={(item.categoryId === 1 || item.categoryId === 4 || item.isUserDefined) ? 'dash' : 'solid'}
                markers={{
                    size: ((item.categoryId === 1 || item.categoryId === -999 || item.categoryId === -888) ? 24 :
                        (item.categoryId === 2 || item.categoryId === 4) ? 15 :
                            (item.categoryId === 5 || item.isUserDefined) ? 9 :
                                (item.categoryId === 3) ? 30 : 24),
                    type: ((item.categoryId === 1 || item.categoryId === -999 || item.categoryId === -888) ? 'circle' :
                        (item.categoryId === 2 || item.categoryId === 4) ? 'square' :
                            (item.categoryId === 5 || item.isUserDefined) ? 'triangle' :
                                (item.categoryId === 3) ? 'cross' : 'circle'),
                    visible: (item.categoryId === -888) ? false : true,
                    background: "none"
                }}
            />
        );
    }

    //to display categories for no data
    const weekWithNoCategoriesData = [{ id: 1, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", totalSessions: 1 }];

    //to display sub categories for no data
    const weekWithNoSubCategoriesData = [
        { id: 1, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: 1, totalSessions: 0.4 },
        { id: 2, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: 1, totalSessions: 0.3 },
        { id: 3, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: 1, totalSessions: 0.2 },
        { id: 4, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: 1, totalSessions: 0.1 }];

    let subCategoriesToSet: any = [];

    //to get colors for category
    const getColorForCategory = (category: any, subCategoriesList: any) => {
        let subcategories = subCategoriesList.filter((x: { categoryId: any; }) => x.categoryId == category.id);
        let total = 10 / subcategories.length;
        subcategories.forEach((element: any, index: any) => {
            let opacity = (total * (subcategories.length - index)) / 10;
            element.color = getColorForSubCategory(element, opacity);
            subCategoriesToSet.push(element);
        });

        let map: any = {
            1: '#0967B1',
            2: '#DA1F6C',
            3: '#008E82',
            4: '#6F4F9B',
            5: '#EA580D',
        };

        if (category.isUserDefined) {
            return '#76A227';
        } else {
            return map[category.id];
        }
    }

    //to get colors for sub category
    const getColorForSubCategory = (element: any, opacity: any) => {
        let alpha = opacity - 0.1;
        let map: any = {
            1: 'rgba(137, 207, 240,' + alpha + ')',
            2: 'rgba(218, 31, 108,' + alpha + ')',
            3: 'rgba(0, 142, 130,' + alpha + ')',
            4: 'rgba(111, 79, 155,' + alpha + ')',
            5: 'rgba(234, 88, 13,' + alpha + ')',
        };

        if (element.isUserDefined) {
            return 'rgba(118, 162, 39,' + alpha + ')';
        } else {
            return map[element.categoryId];
        }
    }

    useEffect(() => {
        getWeeklyBreakdownDetails();
    }, []);

    //to set week index for navigation
    const [weekIndex, setWeekIndex] = useState<any>(0);

    //to build data for charts
    const BuildDataForCharts = (firstWeekdata: any) => {
        if (firstWeekdata?.totalSessions > 0) {
            firstWeekdata.weeklyBreakDownCategoryDtos.map((element: any) => {
                element.color = getColorForCategory(element, firstWeekdata.weeklyBreakDownSubCategoryDtos);
            });
            setTotalHours(firstWeekdata.totalHours);
            setTotalMinutes(firstWeekdata.totalMinutes);
            setTotalSessions(firstWeekdata.totalSessions);
            setNotes(firstWeekdata.notes);
            setWeekCommencing(firstWeekdata.weekCommencing);
            setIsDccExceededContract(firstWeekdata.dccTotal);
            setIsIccExceededContract(firstWeekdata.iccTotal);
            setContractedSessions(firstWeekdata.totalContractedSessions);
            setIccPercentage(firstWeekdata.totalIccPercentage);
            setContractPercentage(firstWeekdata.totalContractPercentage);
            setCategories(firstWeekdata.weeklyBreakDownCategoryDtos);
            setSubCategories(subCategoriesToSet);
            setCategoriesCopy(JSON.parse(JSON.stringify(firstWeekdata.weeklyBreakDownCategoryDtos)));
            setSubCategoriesCopy(JSON.parse(JSON.stringify(subCategoriesToSet)));
            setLineChartCategories(firstWeekdata.lineChartCategoryDtos);
        } else {
            setTotalHours(0);
            setTotalMinutes(0);
            setTotalSessions(0);
            setNotes([]);
            setIsDccExceededContract(0);
            setIsIccExceededContract(0);
            setWeekCommencing(firstWeekdata?.weekCommencing);
            setIccPercentage(0);
            setContractedSessions(0);
            setContractPercentage(0);
            setCategories(weekWithNoCategoriesData);
            setSubCategories(weekWithNoSubCategoriesData);
            setLineChartCategories([]);
        }
        const initialExpanded: any = firstWeekdata?.weeklyBreakDownCategoryDtos.reduce(
            (acc: any, cur: any) => ({ ...acc, [cur.id]: true }),
            {}
        );
        setExpanded({ ...initialExpanded });
    }

    //to build chart data
    const setChartData = (totalNumberOfWeeks: any, weeklyBreakDownDetails: any, isLeaveToggleChecked: any, isPublicHolidayToggleChecked: any) => {
        setTotalNumberOfWeeks(totalNumberOfWeeks,);
        setWeeklyBreakdownData(weeklyBreakDownDetails);
        props.setWeeklyBreakDownData({
            weeklyBreakDownDetails: weeklyBreakDownDetails, totalNumberOfWeeks: totalNumberOfWeeks,
            isLeaveToggleChecked: isLeaveToggleChecked, isPublicHolidayToggleChecked: isPublicHolidayToggleChecked
        });
        if (weeklyBreakDownDetails[0]) {
            let firstWeekdata = weeklyBreakDownDetails[0];
            setWeekIndex(0);
            BuildDataForCharts(firstWeekdata);
        }
    }

    //to get weekly breakdown details
    const getWeeklyBreakdownDetails = () => {
        let payload: any = {};
        payload.startDate = new Date(props.startDate.getFullYear(), props.startDate.getMonth(), props.startDate.getDate(), 0, 0, 0);
        payload.endDate = new Date(props.endDate.getFullYear(), props.endDate.getMonth(), props.endDate.getDate(), 23, 59, 59);
        payload.employerID = props.employerID;
        ReportService.getWeeklyBreakdownDetails(payload).then((response: any) => {
            if (response && response.data) {
                setWeeklyBreakDownResponse(response.data);
                //to check if leave exists in all weeks and public holiday exists in all weeks
                if (response.data.isLeaveExistsInAllWeeks && response.data.isPublicHolidayExistsInAllWeeks) {
                    setChartData(response.data.totalNumberOfWeeks, response.data.weeklyBreakDownDetailsDtos,false,false);
                }
                //to check if leave exists in all weeks 
                else if (response.data.isLeaveExistsInAllWeeks) {
                    setIsLeaveExistsInAllWeeks(true);
                    if (response.data.isPublicHolidayExistInPeriod) {
                        setIsPublicHolidayExistInPeriod(true);
                        setIsExcludePublicHolidayToggelChecked(true);
                        setChartData(response.data.totalNumberOfWeeksExcludingPublicHoliday, response.data.weeklyBreakDownDetailsDtosExcludingPulicHoliday,false,true);
                    }
                    else {
                        setChartData(response.data.totalNumberOfWeeks, response.data.weeklyBreakDownDetailsDtos,false,false);
                    }
                }
                //to check if holiday exists in all weeks
                else if (response.data.isPublicHolidayExistsInAllWeeks) {
                    setIsPublicHolidayExistsInAllWeeks(true);
                    if (response.data.isLeaveExistInPeriod) {
                        setIsLeaveExistInPeriod(true);
                        setIsExcludeLeaveToggelChecked(true);
                        setChartData(response.data.totalNumberOfWeeksExcludingLeave, response.data.weeklyBreakDownDetailsDtosExcludingLeave,true,false);
                    }
                    else {
                        setChartData(response.data.totalNumberOfWeeks, response.data.weeklyBreakDownDetailsDtos,false,false);
                    }
                }
                //to check if leave not exists in all weeks and public holiday not exists in all weeks
                if (!response.data.isLeaveExistsInAllWeeks && !response.data.isPublicHolidayExistsInAllWeeks) {
                    if (response.data.isLeaveExistInPeriod && response.data.isPublicHolidayExistInPeriod) {
                        setChartData(response.data.totalNumberOfWeeksExcludingLeaveandPublicHoliday, response.data.weeklyBreakDownDetailsDtosExcludingLeaveAndPublicholiday,true,true);
                        setIsLeaveExistInPeriod(true);
                        setIsExcludeLeaveToggelChecked(true);
                        setIsPublicHolidayExistInPeriod(true);
                        setIsExcludePublicHolidayToggelChecked(true);
                    }
                    else if (response.data.isLeaveExistInPeriod) {
                        setChartData(response.data.totalNumberOfWeeksExcludingLeave, response.data.weeklyBreakDownDetailsDtosExcludingLeave,true,false);
                        setIsLeaveExistInPeriod(true);
                        setIsExcludeLeaveToggelChecked(true);
                    }
                    else if (response.data.isPublicHolidayExistInPeriod) {
                        setChartData(response.data.totalNumberOfWeeksExcludingPublicHoliday, response.data.weeklyBreakDownDetailsDtosExcludingPulicHoliday,false,true);
                        setIsPublicHolidayExistInPeriod(true);
                        setIsExcludePublicHolidayToggelChecked(true)
                    }
                    else {
                        setChartData(response.data.totalNumberOfWeeks, response.data.weeklyBreakDownDetailsDtos,false,false);
                    }
                }
            }
        })
            .catch((error: any) => {
                console.log(error);
                SweetAlertService.error("Error", "Something went wrong while loading weeklyBreakdown chart");
            });
    }

    //to set week data on change
    const setWeekDataOnChange = (weekIndex: any) => {
        if (weekIndex >= 0) {
            BuildDataForCharts(weeklyBreakdownData[weekIndex]);
        }
    }

    const onAction = useCallback(
        (id: any) => {
            setExpanded({ ...expanded, [id]: !expanded[id] });
        },
        [expanded]
    );

    //to render donut center data
    const donutCenterRenderer = () => {
        return (
            <span className="fs-5">
                {clickedSegment?.name ? (
                    <div>
                        <h5 className="text-dark fs-5">{clickedSegment.totalHours}h {clickedSegment.totalMinutes < 10 ? '0' : '' + clickedSegment.totalMinutes}m</h5>
                        <h5 className="text-dark fs-5">{clickedSegment.name}</h5>
                    </div>
                ) :
                    (
                        <div>
                            <h2 className="text-dark fs-5">{totalHours}h {totalMinutes < 10 ? '0' : '' + totalMinutes}m</h2>
                        </div>
                    )
                }
            </span>
        )
    }

    //To show the the tooltip onclick and onhover the donut chart
    const renderTooltip = (context: any) => {
        if (totalSessions > 0) {
            const { category, series } = context.point || context;
            const dataItem = series.data.find((item: any) => item.name === category);
            return (
                <div>
                    <p className="mb-1">{category}</p>
                    <p className="mb-1">{dataItem.totalSessions?.toFixed(2)} sessions</p>
                    <p className="mb-1">{dataItem.totalHours?.toFixed(0)}h {dataItem.totalMinutes?.toFixed(0)}m</p>
                    <p className="mb-1">{dataItem.percentage?.toFixed(1)}%</p>
                </div>);
        }
    };

    //to get original color of sub categories
    const getSubCategoryOriginalColor = (subCategoryId: any) => {
        let ele = subCategoriesCopy.filter((x: { id: any; }) => x.id == subCategoryId)[0];
        return ele.color;
    }

    //on click of donut chart
    const handleOnClick = (event: any) => {
        if (totalSessions > 0) {
            const { category, series } = event.point;
            let categoryId = event.series.name == "categories" ? event.dataItem.id : event.dataItem.categoryId;
            let map: any = {
                1: 'rgba(137, 207, 240,0.2)',
                2: 'rgba(218, 31, 108,0.2)',
                3: 'rgba(0, 142, 130,0.2)',
                4: 'rgba(111, 79, 155,0.2)',
                5: 'rgba(234, 88, 13,0.2)',
            };
            let mapO: any = {
                1: '#0967B1',
                2: '#DA1F6C',
                3: '#008E82',
                4: '#6F4F9B',
                5: '#EA580D',
            };
            categories.forEach((element: any) => {
                if (element.id != categoryId) {
                    element.color = element.isUserDefined ? 'rgba(118, 162, 39, 0.2)' : map[element.id];
                } else {
                    element.color = element.isUserDefined ? '#76A227' : mapO[element.id];
                }
            });
            let alpha = 0.2;
            let mapSubCategory: any = {
                1: 'rgba(137, 207, 240,' + alpha + ')',
                2: 'rgba(218, 31, 108,' + alpha + ')',
                3: 'rgba(0, 142, 130,' + alpha + ')',
                4: 'rgba(111, 79, 155,' + alpha + ')',
                5: 'rgba(234, 88, 13,' + alpha + ')',
            };
            subCategories.forEach((element: any, index: any) => {
                if (element.categoryId != categoryId) {
                    element.color = element.isUserDefined ? 'rgba(118, 162, 39,' + alpha + ')' : mapSubCategory[element.categoryId]
                } else {
                    element.color = getSubCategoryOriginalColor(element.id)
                }
            });

            const clickedDataItem = series.data.find((item: any) => item.name === category);
            if (clickedDataItem) {
                // Set the clicked segment's data
                setClickedSegment({
                    name: clickedDataItem.name,
                    totalHours: clickedDataItem.totalHours,
                    totalMinutes: clickedDataItem.totalMinutes,
                    id: clickedDataItem.id,
                });
            }
            setCategories(categories);
            setSubCategories(subCategories);
        }
    }

    //To reset the chart on click of legends
    const reset = () => {
        if (totalSessions > 0) {
            setCategories(JSON.parse(JSON.stringify(categoriesCopy)));
            setSubCategories(JSON.parse(JSON.stringify(subCategoriesCopy)));
            setClickedSegment({});
        }
    }

    //to remove the color change on hover of donut chart
    const handleOnHover = (event: any) => {
        event.point.options.highlight.visible = false;
    }

    //to navigate to next week
    const handleNextWeek = () => {
        setWeekIndex(weekIndex + 1);
        setWeekDataOnChange(weekIndex + 1);
    };

    //to navigate to previous week
    const handlePreviousWeek = () => {
        setWeekIndex(weekIndex - 1);
        setWeekDataOnChange(weekIndex - 1);
    };

    // to hide the error message for leave and public holiday
    const hideErrorMessagesForLeaveAndPublicHoliday = () => {
        setShowErrorMessageForLeaveToggle(false);
        setShowErrorMessageForPublicHolidayToggle(false);
    }

    //to reset all the chart detalis
    const resetChartData = () => {
        setTotalHours(0);
        setTotalMinutes(0);
        setTotalSessions(0);
        setNotes([]);
        setIsDccExceededContract(0);
        setIsIccExceededContract(0);
        setWeekCommencing('');
        setIccPercentage(0);
        setContractedSessions(0);
        setContractPercentage(0);
        setCategories([]);
        setSubCategories([]);
        setCategoriesCopy([]);
        setSubCategoriesCopy([]);
        setLineChartCategories([]);
    }

    //To call method when user change the values of Leave toggele
    const onExcludeLeaveChange = (event: any) => {
        if (isLeaveExistsInAllWeeks) {
            setShowErrorMessageForLeaveToggle(true);
        }
        else {
            reset();
            resetChartData();
            setIsExcludeLeaveToggelChecked(event.value);
            let weeklyBreakDownData = weeklyBreakDownResponse;
            if (event.value && isExcludePublicHolidayToggelChecked) {
                setChartData(weeklyBreakDownData.totalNumberOfWeeksExcludingLeaveandPublicHoliday, weeklyBreakDownData.weeklyBreakDownDetailsDtosExcludingLeaveAndPublicholiday,true,true);
            } else if (event.value) {
                setChartData(weeklyBreakDownData.totalNumberOfWeeksExcludingLeave, weeklyBreakDownData.weeklyBreakDownDetailsDtosExcludingLeave,true,false);
            } else if (isExcludePublicHolidayToggelChecked) {
                setChartData(weeklyBreakDownData.totalNumberOfWeeksExcludingPublicHoliday, weeklyBreakDownData.weeklyBreakDownDetailsDtosExcludingPulicHoliday,false,true);
            } else {
                setChartData(weeklyBreakDownData.totalNumberOfWeeks, weeklyBreakDownData.weeklyBreakDownDetailsDtos,false,false);
            }
        }
    }

    //To call method when user change the values of Leave toggele
    const onExcludePublicHolidayChange = (event: any) => {
        if (isPublicHolidayExistsInAllWeeks) {
            setShowErrorMessageForPublicHolidayToggle(true);
        }
        else {
            reset();
            resetChartData();
            setIsExcludePublicHolidayToggelChecked(event.value);
            let weeklyBreakDownData = weeklyBreakDownResponse;
            if (event.value && isExcludeLeaveToggelChecked) {
                setChartData(weeklyBreakDownData.totalNumberOfWeeksExcludingLeaveandPublicHoliday, weeklyBreakDownData.weeklyBreakDownDetailsDtosExcludingLeaveAndPublicholiday,true,true);
            } else if (event.value) {
                setChartData(weeklyBreakDownData.totalNumberOfWeeksExcludingPublicHoliday, weeklyBreakDownData.weeklyBreakDownDetailsDtosExcludingPulicHoliday,false,true);
            } else if (isExcludeLeaveToggelChecked) {
                setChartData(weeklyBreakDownData.totalNumberOfWeeksExcludingLeave, weeklyBreakDownData.weeklyBreakDownDetailsDtosExcludingLeave,true,false);
            }
            else {
                setChartData(weeklyBreakDownData.totalNumberOfWeeks, weeklyBreakDownData.weeklyBreakDownDetailsDtos,false,false);
            }
        }
    }

    //to set x axis values for line chart
    const weekRange = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-5 mb-2 p-0">
                        {
                            isPublicHolidayExistInPeriod && !isPublicHolidayExistsInAllWeeks &&
                            (
                                <div className="mb-1">
                                    <Switch size="small" defaultChecked={isPublicHolidayExistInPeriod} onLabel={""} offLabel={""} onChange={onExcludePublicHolidayChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with public holidays</label>
                                </div>
                            )
                        }
                        {
                            !isPublicHolidayExistInPeriod && !isPublicHolidayExistsInAllWeeks &&
                            (
                                <div className="mb-1">
                                    <Switch size="small" onLabel={""} offLabel={""} disabled />
                                    <label className="form-check-label text-secondary ms-2">Exclude weeks with public holidays</label>
                                </div>
                            )
                        }
                        {
                            isPublicHolidayExistsInAllWeeks &&
                            (
                                <div className="mb-1">
                                    <Switch size="small" checked={!isPublicHolidayExistsInAllWeeks} onLabel={""} offLabel={""} onChange={onExcludePublicHolidayChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with public holidays</label>
                                </div>
                            )
                        }
                        {showErrorMessageForPublicHolidayToggle && <span className="help-block mb-2 text-danger field-validation-valid">Public holidays occur in all weeks of the reporting period.</span>}
                        {
                            isLeaveExistInPeriod && !isLeaveExistsInAllWeeks &&
                            (
                                <div className="mb-0">
                                    <Switch size="small" defaultChecked={isLeaveExistInPeriod} onLabel={""} offLabel={""} onChange={onExcludeLeaveChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with leave</label>
                                </div>
                            )
                        }
                        {
                            !isLeaveExistInPeriod && !isLeaveExistsInAllWeeks &&
                            (
                                <div className="mb-0">
                                    <Switch size="small" onLabel={""} offLabel={""} disabled />
                                    <label className="form-check-label text-secondary ms-2">Exclude weeks with leave</label>
                                </div>
                            )
                        }
                        {
                            isLeaveExistsInAllWeeks &&
                            (
                                <div className="mb-0">
                                    <Switch size="small" checked={!isLeaveExistsInAllWeeks} onLabel={""} offLabel={""} onChange={onExcludeLeaveChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with leave</label>
                                </div>
                            )
                        }
                        {showErrorMessageForLeaveToggle && <span className="help-block m-b-none text-danger field-validation-valid">Leave occurs in all weeks of the reporting period.</span>}
                    </div>
                    <div className="col-lg-5" onClick={hideErrorMessagesForLeaveAndPublicHoliday}></div>
                </div>
            </div>
            <div className="Container-fluid" onClick={hideErrorMessagesForLeaveAndPublicHoliday}></div>
            <span className="text-muted">Weeks showing: {totalNumberOfWeeks}</span><br />
            <div className="float-end mb-5">
                {weekIndex != 0 && (
                    <button className="btn btn-secondary py-3" onClick={handlePreviousWeek}>
                        <i className="bi bi-chevron-left"></i> Previous Week
                    </button>
                )}
                {(weekIndex != totalNumberOfWeeks - 1) && (
                    <button className="btn btn-secondary py-3 ms-2" onClick={handleNextWeek}>
                        Next Week <i className="bi bi-chevron-right"></i>
                    </button>
                )}
            </div><br/><br/><br/>
            <p>Week commencing {moment(weekCommencing).format('DD/MM/yyyy')}</p>
            <div className="Container-fluid" onClick={hideErrorMessagesForLeaveAndPublicHoliday}>
                <div className="row">
                    <div className="col-lg-12">
                        <Chart transitions={false}>
                            <ChartTitle text="hours" position="top" align="left" />
                            <ChartCategoryAxis>
                                <ChartCategoryAxisItem
                                    title={{ text: "Day", position: "bottom" }}
                                    categories={weekRange}
                                />
                            </ChartCategoryAxis>
                            <ChartSeries>
                                {
                                    lineChartCategories.map(mapSeries)
                                }
                            </ChartSeries>
                        </Chart>
                    </div>
                </div>
            </div>
            <div className="Container-fluid">
                <div className="row">
                    <div className="col-lg-6" onClick={reset}>
                        {totalSessions == 0 && (
                            <p className ="ms-2">No activities in diary for this week.</p>
                        )}
                        <Chart transitions={false} donutCenterRender={donutCenterRenderer} onSeriesClick={handleOnClick} onSeriesHover={handleOnHover}>
                            <ChartTooltip render={renderTooltip} background="#fff" />
                            <ChartLegend visible={false} />
                            <ChartArea background="none" />
                            <ChartSeries>
                                <ChartSeriesItem
                                    name="subCategories"
                                    width={500}
                                    type="donut"
                                    startAngle={0}
                                    field="totalSessions"
                                    categoryField="name"
                                    data={subCategories}
                                    colorField="color"
                                    size={40}
                                    holeSize={50}
                                    margin={3} >
                                </ChartSeriesItem>
                                <ChartSeriesItem
                                    name="categories"
                                    width={500}
                                    type="donut"
                                    startAngle={0}
                                    field="totalSessions"
                                    categoryField="name"
                                    data={categories}
                                    colorField="color"
                                    size={60}
                                    holeSize={50}
                                    margin={3} >
                                </ChartSeriesItem>
                            </ChartSeries>
                        </Chart>
                    </div>
                    <div className="col-lg-2" onClick={reset}>
                    </div>
                    <div className="col-lg-4 mt-5">
                        {categories && categories.map((category: any, index: any) => (
                            <Fragment key={index}>
                                <ExpansionPanel
                                    expandIcon="k-icon k-i-arrow-60-right"
                                    collapseIcon="k-icon k-i-arrow-60-down"
                                    style={{ border: 'none', borderBottom: "2px solid lightgrey" }}
                                    expanded={expanded[category.id]}
                                    tabIndex={0}
                                    key={category.id}
                                    onAction={onAction.bind(undefined, category.id)}
                                    title={
                                        <div className="row mt-2">
                                            <span className="mr-2">
                                                <svg width="50" height="50">
                                                    <circle cx="25" cy="25" r="25" fill={category.color} fillOpacity="0.3" />
                                                    <circle cx="25" cy="25" r="15" fill={category.color} fillOpacity="0.7" />
                                                    <circle cx="25" cy="25" r="5" fill={category.color} fillOpacity="1" />
                                                </svg>
                                                <label className="text-dark ps-2"><b>{category.name} - {category.totalHours?.toFixed(0)}h {category.totalMinutes?.toFixed(0)}m</b></label>
                                            </span>
                                        </div>
                                    }
                                />
                                {subCategories.filter((x: any) => x.categoryId == category.id).map((subCategory: any, index: any) => (
                                    <Fragment key={index}>
                                        {expanded[category.id] && (
                                            <div className="container-fluid">
                                                <ExpansionPanelContent >
                                                    <div className="row mt-2">
                                                        <span className="col-1 ps-4 ms-1">
                                                            <svg width="20" height="20">
                                                                <circle cx="10" cy="10" r="10" fill={subCategory.color} />
                                                            </svg>
                                                        </span>
                                                        <label className="col-6 ps-4 ms-1">{subCategory.name}</label>
                                                        <label className="col-4 ps-3">{subCategory.totalHours?.toFixed(0)}h {subCategory.totalMinutes?.toFixed(0)}m</label>
                                                    </div>
                                                </ExpansionPanelContent>
                                            </div>
                                        )}
                                    </Fragment>
                                ))}
                            </Fragment>
                        ))}
                    </div>
                </div>
                <div className="mt-4">
                    {/* Notes data */}
                    {notes.length > 0 && (
                        <div>
                            <h5 className="mb-1 text-dark">Notes for this week</h5>
                            {notes.map((item: any, index: any) => (
                                <div key={index}>
                                    <h5 className="text-muted mb-0">
                                        {moment(item.activityStartDate).format('DD/MM/yyyy')}{' '}
                                        {moment(item.activityStartDate).format('HH:mm')}-{moment(item.activityEndDate).format('HH:mm')}{' '}
                                        {item.categoryName}-{item.subCategoryName}<br />
                                    </h5>
                                    <span className="text-secondary">{item.notes}</span><br />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                {contractedSessions > 0 && isDccExceededContract > contractedSessions ? (
                    <span className="red-text mb-2">
                        <svg className="bi bi-dash-circle-fill" width="16" height="16" fill="red" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                        </svg>&nbsp;
                        <p className="mb-2">Total DCC is more than contracted hours</p>
                    </span>
                ):null}<br />
                {contractedSessions > 0 && (isDccExceededContract && isIccExceededContract > contractedSessions) ? (
                    <span className="red-text mb-2">
                        <svg className="bi bi-dash-circle-fill" width="16" height="16" fill="red" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                        </svg>&nbsp;
                        <p className="mb-2">Total DCC and ICC is more than contract hours.</p>
                    </span>
                ):null}
                {iccPercentage > 0 ? (
                    <p className="mb-1">Your ICC is {iccPercentage.toFixed(0)}% of your DCC plus ICC time.</p>) : null}
                {contractPercentage > 0 ? (
                    <p>Your contract hours are {contractPercentage.toFixed(0)}% of your worked total.</p>
                ) : null}
            </div>
        </>
    );
} 